import { render, staticRenderFns } from "./EntityAttention.vue?vue&type=template&id=197b9f2b&scoped=true"
import script from "./EntityAttention.vue?vue&type=script&lang=js"
export * from "./EntityAttention.vue?vue&type=script&lang=js"
import style0 from "./EntityAttention.vue?vue&type=style&index=0&id=197b9f2b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b9f2b",
  null
  
)

export default component.exports